<!--
 * @Author: cryi.liu
 * @Date: 2020-05-01 15:13:23
 * @LastEditTime: 2020-05-25 17:07:35
 * @Description: 原 PSS 风格侧栏
 -->
<template>
  <div class="pss__sider">
    <sider-head />
    <sider-menu />
  </div>
</template>

<script>
import SiderHead from './Head.vue';
import SiderMenu from './Menu.vue';

export default {
  name: 'PssSider',
  components: {
    SiderHead,
    SiderMenu,
  },
};
</script>

<style lang="less" scoped>
.pss__sider {
  flex: 0 0 216px;
  margin-right: 12px;
  background: url('../../../../assets/image/bg-sider-menu-line.jpg') repeat-y;
  border-radius: 16px;
  overflow: hidden;
}
</style>
